module.exports = __webpack_public_path__ + "img/core_value_right.0ae81aa8.png";